import { AuthManager } from "features/Authentication/AuthManager"

/**
 * Accounts appends this to every post-auth redirect when the session was created
 * through a shadow login. It's only ever sent as the literal string "true",
 * never as "false".
 */
export const SHADOW_SEARCH_PARAM = "shadow"

/**
 * Sent as the `device-id` header on every API request made during a shadow session.
 */
export const SHADOW_DEVICE_ID = "shadow-login"

/**
 * The `shadow` search param should only be read here and at the entry points
 * that exchange the auth code. Everywhere else should use `isShadow`.
 */
export const readShadowFromSearchParams = (params: URLSearchParams) =>
  params.get(SHADOW_SEARCH_PARAM) === "true"

/**
 * Shadow login is student only, so this reads the student auth object. Platform
 * override sessions (school, recruiter, centre) never carry the flag.
 *
 * The URL is checked alongside the stored auth object because analytics boot up
 * before the auth code has been exchanged and persisted. The entry points strip
 * the param once the flag is on the auth object.
 *
 * This is a hint, not an access control. It only ever removes capability, so a
 * user setting it on their own session is harmless. Never use it to grant anything.
 */
export const isShadow = () =>
  AuthManager.getPlatformAuth()?.shadow === true ||
  readShadowFromSearchParams(new URLSearchParams(window.location.search))
